import Dashboard from './Dashboard';
import Signin from './Signin';
import Signup from './Signup';
import Home from './Home';

export default {
  private: [
    {
      component: Dashboard,
      exact: true,
      path: '/dashboard',
    },
  ],
  public: [
    {
      component: Home,
      exact: true,
      path: '/home',
    },
    {
      component: Signin,
      exact: true,
      path: '/signin',
    },
    {
      component: Signup,
      exact: true,
      path: '/signup',
    },
  ],
};
